// extracted by mini-css-extract-plugin
export var activityContainer = "_lx-0";
export var typingIndicatorContainer = "_lx-1";
export var typingIndicatorDot = "_lx-2";
export var wave = "_lx-3";